function repairPayload(preview, note, now = Date.now()) {
  if (!preview || preview.success !== true || preview.repairEligible !== true
    || !Array.isArray(preview.blockers) || preview.blockers.length
    || typeof preview.bookingId !== 'string' || !preview.bookingId
    || !/^[a-f0-9]{64}$/.test(preview.claimFingerprint || '')
    || !/^[a-f0-9]{64}$/.test(preview.evidenceFingerprint || '')
    || !Number.isFinite(preview.previewExpiresAt) || preview.previewExpiresAt <= now) {
    throw new Error('Önizleme geçersiz veya süresi doldu. Önce tekrar kontrol edin.');
  }
  if (typeof note !== 'string' || !note.trim() || note.length > 1000) throw new Error('1–1000 karakter arasında bir işlem açıklaması yazın.');
  return { bookingId: preview.bookingId, claimFingerprint: preview.claimFingerprint, evidenceFingerprint: preview.evidenceFingerprint, note: note.trim() };
}

function validatePage(page) {
  if (page?.success !== true || !Array.isArray(page.items)
    || !Number.isInteger(page.scannedCount) || page.scannedCount < 0 || page.scannedCount > 50
    || typeof page.hasMore !== 'boolean' || (page.hasMore && (typeof page.nextCursor !== 'string' || !page.nextCursor))) {
    throw new Error('Sunucu yanıtı doğrulanamadı. Bu sayfa kontrol edilmiş sayılmaz.');
  }
  return page;
}

module.exports = { repairPayload, validatePage };
